import { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

class Carousel extends Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        numberOfSlides: PropTypes.number.isRequired,
        locked: PropTypes.bool,
        startIndex: PropTypes.number,
        autoplay: PropTypes.bool,
        duration: PropTypes.number,
    };

    static defaultProps = {
        locked: false,
        startIndex: 0,
        autoplay: false,
        duration: 5000,
    };

    state = {
        activeIndex: this.props.startIndex, // eslint-disable-line react/destructuring-assignment
        animationDirection: 'forward',
    };

    componentDidMount() {
        this.resetTimer();
    }

    componentDidUpdate(prevProps, prevState) {
        const { activeIndex } = this.state;
        if (prevState.activeIndex !== activeIndex) this.resetTimer();
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    clearTimer = () => {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    };

    resetTimer = () => {
        const { autoplay, duration } = this.props;
        this.clearTimer();
        if (autoplay) this._timer = setTimeout(this.next, duration);
    };

    goto = index =>
        this.setState(prev => ({
            animationDirection: index > prev.activeIndex ? 'forward' : 'backward',
            activeIndex: index,
        }));

    next = () => {
        const { numberOfSlides } = this.props;
        this.setState(prev => ({
            animationDirection: 'forward',
            activeIndex: prev.activeIndex === numberOfSlides - 1 ? 0 : prev.activeIndex + 1,
        }));
    };

    prev = () => {
        const { numberOfSlides } = this.props;
        this.setState(prev => ({
            animationDirection: 'backward',
            activeIndex: prev.activeIndex === 0 ? numberOfSlides - 1 : prev.activeIndex - 1,
        }));
    };

    render() {
        const { locked, children } = this.props;
        const { activeIndex, animationDirection } = this.state;

        return children({
            animationDirection,
            activeSlide: activeIndex,
            nextSlide: locked ? noop : this.next,
            prevSlide: locked ? noop : this.prev,
            gotoSlide: locked ? noop : this.goto,
        });
    }
}

export default Carousel;
